// dependencies.
import { get } from 'lodash'

// detect the base URL.
const LOGIN_TO_PROFESSIONAL = get(process.env, 'LOGIN_TO_PROFESSIONAL')

/**
 * login professional route
 */
export default LOGIN_TO_PROFESSIONAL



// WEBPACK FOOTER //
// ./src/plugins/http/professional.js